createSafeModule('app.catalogo', [
    'ui.router',
    'ngResource',
    'lazyLoad'
]);